import React, { Component, Fragment } from 'react'
import RichTextEditor from 'react-rte'
import PropTypes from 'prop-types'
import HamburgerNavbar from './hamburgerNavbar'
import List2 from './list2.js'
import { FormGroup, ControlLabel, FormControl, Button, Modal, Row, Col, Checkbox, Form } from 'react-bootstrap'
import { deepValue, getParams, end_point, getSeasons, validateEmail } from './helper'
import { faCheck, faTimes, faPaperclip } from '@fortawesome/free-solid-svg-icons'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import moment from 'moment'

var $ = require('jquery');


class notifications extends Component {
  constructor(props){
    super(props)
    this.state = {
      editorBorder: "",
      to: "",
      subject: "",
      group: getParams().program_id && !getParams().toTeams? "program":"select",
      program: getParams().program_id && !getParams().toTeams? getParams().program_id:"select",
      season: "",
      email_to_names: "",
      email_spinner: false,
      email_sent: false,
      email_groups: [],
      files: [],
      all_users: [],
      all_teams: [],
      selectedUsers: [],
      selectedTeams: [],
      selectedPrograms: [],
      programEmails: "",
      toTeams: {},
      spinner: false,
      show_modal: false,
      marketingEmail: false,
      token: getParams().jwt || localStorage.getItem('jwt') || '',
      value: RichTextEditor.createEmptyValue(),
      organization_id: getParams().organization_id || localStorage.getItem("organization_id") || '',
      portal_endpoint: `${end_point()}/portal`,
      emailing_endpoint: `${end_point()}/notify`,
      get_groups_endpoint: `${end_point()}/notification_groups`,
      get_all_emails_endpoint: `${end_point()}/group_emails`,
      broadcasts: (getParams().broadcasts === "true"),
      labelFields: [{"name":"first_name", "size": "30%"}, {"name":"last_name", "size":"30%"}, {"name":"type", "size":"10%"}, {"name":"email", "size": "30%"}],
      labelFieldsTeam: [{"name":"season", "size": "20%"}, {"name":"age_group", "size":"20%"}, {"name":"division", "size":"20%"}, {"name":"program_name", "size": "20%"},
      {"name":"team_name", "size": "20%"} ],
      labelFieldsPrograms: [{"name":"season", "size": "20%"},  {"name":"ages", "size":"20%"},  {"name":"division", "size":"20%"}, {"name":"group_name", "size": "20%"},  ],
    }
  }

  static propTypes = {
    onChange: PropTypes.func
  }

  handleModalClose = () => {
    if (this.state.email_sent) {
      this.setState({
        show_modal: false,
        subject: "",
        email_to_names: "",
        to: "",
        email_sent: false
      })
    } else {
      this.setState({ show_modal: false })
    }
    
  }

  handleModalShow = () => {
    const { group } = this.state
    if (group === "select") {
      window.alert("Please select an audience")
    } else if (group === "individual" || group === "team" || group === "program") {
      if (this.state.to.trim() === ""){ 
        console.log(`${group} emails to:`, this.state.to)
        window.alert("Please specify at least one recipient.")
      } else {
        console.log("Document value", document.getElementById("to").value)
        let removeDuplicates = document.getElementById("to").value.split(",").reduce((unique, item) => 
        unique.includes(item) ? unique : [...unique, item], [])
        this.setState({
          to: removeDuplicates.join(","), 
          show_modal: true
        }, ()=> {console.log("Email to:", this.state.to)})
      }
    } else if (group === "season") {
      if (document.getElementById("season_selection").value === "select"){
        window.alert("Please Select a season")
      } else {
        var athletes = [];
        var email_users = [];
        var season = document.getElementById("season_selection").value
        this.state.email_groups.forEach(data => {
          //find the selected season
          if(data.season === season){
          //find athletes in the program with status enrolled
          data.enrolled_users.forEach( enrolled_user => {
            if( !enrolled_user.status || enrolled_user.status === "enrolled") {
                athletes.push(enrolled_user)
              }
            })
            email_users.push(data.head_coach)
            if(data.assistantCoaches.length!== 0){
              data.assistantCoaches.forEach(assistant_id => {
                email_users.push(assistant_id)
              })
            }
          }
        })
        athletes.forEach(athlete => {
          email_users.push(this.getParentId(athlete._id));
        })
        //remove duplicates
        var parents_and_coaches = Array.from(new Set(email_users));
        for(var i = 0; i < parents_and_coaches.length; i++){
          parents_and_coaches[i] = {"_id": parents_and_coaches[i]}
        }
        var program_users_emails = this.getProgramUserEmails(parents_and_coaches)
        if (program_users_emails[0] === ""){ 
          console.log(`${group} emails to:`, program_users_emails[0])
          window.alert("Please specify at least one recipient.")
        } else {
          this.setState({
            to: program_users_emails[0], 
            email_to_names: program_users_emails[1],
            show_modal:true
          })
        }
      }
    } else {
      var user_emails = this.getEmails(this.state.group)
      this.setState({to: user_emails[0], email_to_names: user_emails[1], show_modal: true})
    }
  }

  getParentId = (id) => {
    var parent_id = "";
    this.state.all_users.forEach( user => {
      if (user._id === id) {
        parent_id = user.parent_id;
      }
    })
    return parent_id;
  }

  getEmails = (type, team = null) => {
    var users_emails = "";
    var users_emails_names = "";
    if(type === "organization"){
      this.state.all_users.forEach(user => {
        if(this.state.marketingEmail === false && validateEmail(user.email)) {
          users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
          users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
          // get secondary contact
          if(user.extras && user.extras.secondary_parent && 
             user.extras.secondary_parent.email && 
             validateEmail(user.extras.secondary_parent.email)){
            users_emails = users_emails + "," + user.extras.secondary_parent.email
            users_emails_names = users_emails_names + `,${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
          }
        } else if (this.state.marketingEmail === true && validateEmail(user.email) && user.marketing_opt_out === false) {
          //if(user.marketing_opt_out === false){
            users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
            users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
            if( user.extras && user.extras.secondary_parent && 
               user.extras.secondary_parent.email && 
               validateEmail(user.extras.secondary_parent.email)){
               users_emails = users_emails + "," + user.extras.secondary_parent.email
               users_emails_names = users_emails_names + `,${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
            }
          //}
        }
      })
    } else if (type === 'coach') {
      this.state.all_users.forEach(user => {
        if (user.type === 'coach' || user.type === 'admin' || user.type === 'manager'){
          if(this.state.marketingEmail === false){
            users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
            users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
          } else {
            if(user.marketing_opt_out === false){
              users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
              users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
            }
          }
        }
      }) 
    } else if (type === 'team'){
      var toTeams = null
      if(team){
        toTeams = team
      } else {
        toTeams = this.state.toTeams
      }
      var users = []
      var user_parents = []
      if(toTeams.team_type && toTeams.team_type === 'Club Team'){
        toTeams.clubteam_info && toTeams.clubteam_info.coaches.forEach(coach => {
          user_parents.push(coach._id)
        })
      } else {
        user_parents.push(toTeams.coach)
      }
      toTeams.items.forEach(item => {
        users.push({"user_id": item._id, "status": item.status})
      })
      this.state.all_users.forEach(user => {
        //only status enrolled users get emails 
        users.forEach(program_user => {
          if(program_user.user_id === user._id && (!program_user.status || program_user.status === 'enrolled')){
            user_parents.push(user.parent_id)
          }
        })
      })
      this.state.all_users.forEach(user =>{
        // console.log("USER", validateEmail(user.email))
        if(user_parents.includes(user._id)){
          if(this.state.marketingEmail === false && validateEmail(user.email)){
            users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
            users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
            if(user.extras && user.extras.secondary_parent && 
               user.extras.secondary_parent.email && 
               validateEmail(user.extras.secondary_parent.email)){
                users_emails = users_emails + "," + user.extras.secondary_parent.email
                users_emails_names = users_emails_names + "," + `${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
              }
          } else if (this.state.marketingEmail === true && validateEmail(user.email) && user.marketing_opt_out === false) {
              users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
              users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
              if(user.extras && user.extras.secondary_parent && 
                  user.extras.secondary_parent.email && 
                  validateEmail(user.extras.secondary_parent.email)){
                    users_emails = users_emails + "," + user.extras.secondary_parent.email
                    users_emails_names = users_emails_names + `,${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
            }
          }
        }
      })
      console.log("GET EMAILS TEAM??", toTeams)
    } else {
      this.state.all_users.forEach(user => {
        if (user.type === type){
          if(this.state.marketingEmail === false && validateEmail(user.email)){
            users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
            users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
            if( user.extras && user.extras.secondary_parent && 
              user.extras.secondary_parent.email && 
              validateEmail(user.extras.secondary_parent.email)){
                users_emails = users_emails + "," + user.extras.secondary_parent.email
                users_emails_names = users_emails_names + `,${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
              }
          } else if (this.state.marketingEmail === true && validateEmail(user.email) && user.marketing_opt_out === false) {
           // if(user.marketing_opt_out === false){
              users_emails===""? users_emails = user.email:users_emails = users_emails + "," + user.email;
              users_emails_names===""? users_emails_names = `${user.first_name} ${user.last_name} ${user.email}`:users_emails_names = users_emails_names + `,${user.first_name} ${user.last_name} ${user.email}`
              if( user.extras && user.extras.secondary_parent && 
                  user.extras.secondary_parent.email && 
                validateEmail(user.extras.secondary_parent.email)){
                  users_emails = users_emails + "," + user.extras.secondary_parent.email
                  users_emails_names = users_emails_names + `,${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name} ${user.extras.secondary_parent.email}`
                }
           // }
          }
        }
      })
    }
    console.log("USER", users_emails, users_emails_names)
    return [users_emails, users_emails_names];
  }

  
  getProgramUserEmails = (userArr) => {
      let program_users_emails = this.state.to
      let program_users_emails_names = ""

    console.log('all_users', this.state.all_users)
    // let response = await 
    this.state.all_users.forEach( all_user => {

      // for (all_user of this.state.all_users) {
       userArr.forEach(program_user => {
        // for (program_user of userArr) {
        if (this.state.marketingEmail === false && validateEmail(all_user.email)) {
          if (all_user._id === program_user._id) {
            program_users_emails === "" ? 
              program_users_emails = all_user.email 
              : 
              program_users_emails = program_users_emails + "," + all_user.email;
            
            program_users_emails_names === "" ? 
              program_users_emails_names = `${all_user.first_name} ${all_user.last_name} ${all_user.email}` 
              : 
              program_users_emails_names = program_users_emails_names + `,${all_user.first_name} ${all_user.last_name} ${all_user.email}`
            
            if (all_user.extras && all_user.extras.secondary_parent && 
               all_user.extras.secondary_parent.email && 
                 validateEmail(all_user.extras.secondary_parent.email)){
                program_users_emails = program_users_emails + "," + all_user.extras.secondary_parent.email
                program_users_emails_names = program_users_emails_names +`,${all_user.extras.secondary_parent.first_name} ${all_user.extras.secondary_parent.last_name} ${all_user.extras.secondary_parent.email}`
              }
          }
        } else if (this.state.marketingEmail === true && validateEmail(all_user.email)) {
          if(all_user._id === program_user._id && all_user.marketing_opt_out === false){
            program_users_emails===""? program_users_emails = all_user.email:program_users_emails = program_users_emails + "," + all_user.email;
            program_users_emails_names===""? program_users_emails_names = `${all_user.first_name} ${all_user.last_name} ${all_user.email}`:program_users_emails_names = program_users_emails_names + `,${all_user.first_name} ${all_user.last_name} ${all_user.email}`
            if( all_user.extras && all_user.extras.secondary_parent && 
                all_user.extras.secondary_parent.email && 
                  validateEmail(all_user.extras.secondary_parent.email)){
             program_users_emails = program_users_emails + "," + all_user.extras.secondary_parent.email
             program_users_emails_names = program_users_emails_names + `,${all_user.extras.secondary_parent.first_name} ${all_user.extras.secondary_parent.last_name} ${all_user.extras.secondary_parent.email}`
          //  }
            }
          }
        }
      })
    })
    const removeDuplicateEmails = program_users_emails.split(",").reduce((unique, item) => 
      unique.includes(item) ? unique : [...unique, item], [])

    const removeDuplicateNames = program_users_emails_names.split(" ").reduce((unique, item) => 
      unique.includes(item) ? unique : [...unique, item], [])

    
    program_users_emails = removeDuplicateEmails.join(",");
    program_users_emails_names = removeDuplicateNames.join(" ");
    console.log('program_users_emails:', program_users_emails, '\nprogram_users_emails_names:',program_users_emails_names)
    this.setState({programEmails: program_users_emails})
    return [program_users_emails, program_users_emails_names];
  }


  handleProgramChange = async (value) => {
    this.setState({program: value._id})
      var email_users = [];

      console.log("EMAILS",this.state.email_groups)

      let programGroup = this.state.email_groups.filter(data => data._id === value._id)[0]

      console.log("programGroup", programGroup)
      email_users.push(programGroup.head_coach)
                
      if(programGroup.assistantCoaches && programGroup.assistantCoaches.length!== 0){
        await programGroup.assistantCoaches.forEach(assistant_id => {
          email_users.push(assistant_id)
        })
      }
      if (programGroup.enrolled_users) {
      await programGroup.enrolled_users.forEach(athlete => {
        if (athlete.status !== "withdrawn" && athlete.status !== "unverified") {
          email_users.push(this.getParentId(athlete._id))
        }
      })
    }
    console.log("EMAILS USERS", email_users)

    var parents_and_coaches = Array.from(new Set(email_users));
    for(var i = 0; i < parents_and_coaches.length; i++){
      parents_and_coaches[i] = {"_id": parents_and_coaches[i]}
    }

    console.log("parents and coaches", parents_and_coaches)
    var program_users_emails = await this.getProgramUserEmails(parents_and_coaches);

    this.setState({to: program_users_emails[0], email_to_names: program_users_emails[1]})

  }

  handleBodyChange = value => {
    this.setState({ value });
  };

  formatRecipientsForDisplay = (value) => {
    return value
      .split(",")
      .map((email) => email.trim())
      .filter(Boolean)
      .join("\n")
  }

  changeToEmail = (value) => {
    this.setState({
      to: value.target.value
        .split(/\n|,/)
        .map((email) => email.trim())
        .filter(Boolean)
        .join(",")
    })
  }

  handleGroup = (value) => {
    if(document.getElementById("search")){
      document.getElementById("search").value = ''
      if(this.state.selectedUsers.length !== 0){
        var selectedUsers = this.state.all_users.slice()
        this.setState({ selectedUsers })
      }
      if(this.state.selectedTeams.length !== 0){
        var selectedTeams = this.state.all_teams.slice()
        this.setState({ selectedTeams })
      }
    }
    if(value.target.value === "season" || value.target.value === "program" || value.target.value === "organization" ||
      value.target.value === "parent" || value.target.value === "individual" ||
      value.target.value === "coach" || value.target.value === "team") {
      this.setState({group: value.target.value, to: "", email_to_names: ""}, ()=> {console.log("GROUP TYPE", this.state.group)});
    } else {
      this.setState({group: "select", to: ""})
    }
  };


  handleSeason = (value) => {
    this.setState({season: value.target.value})
  };

  getUserEmailsByIds(userArr){
    var email = ""
    this.state.all_emails.forEach(data => {
      userArr.forEach(user => {
        if(user._id === data._id){
          email === ""?email = data.email:email = email+","+data.email;
        }
      })
    })
    return email
  }

  handleSubjectChange = (subject) => {
    this.setState({ subject: subject.target.value })
  }


  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  handleSubmit = async () => {
    var rthis = this;
    var rRichTextEditor = RichTextEditor;
    this.setState({ email_spinner: true })
    var attachments = []
    var convertedFiles = []
    for (var file of this.state.files) {
      var converted = await this.toBase64(file)
      console.log('converted file')
      convertedFiles.push(converted)
    }
    console.log('attachments???', attachments)
    var data = {
      "to": this.state.to,
      "body": this.state.value.toString("html"),
      "subject": this.state.subject,
    }
    if (convertedFiles.length > 0) {
      convertedFiles.forEach((result, i) => {
        attachments.push({
          "type": this.state.files[i].type,
          "fileName": this.state.files[i].name,
          "file": result.split(',')[1]
        })
      })
      data.attachments = attachments
    }
    console.log('data to send', data)
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      url: this.state.emailing_endpoint,
      error: function(data) {
        console.log('error: coming back from sending email', data)
        alert("Something went wrong. Please contact support\n", data.statusText)
        rthis.setState({ email_spinner: false})
      },
      success: function (data) {
        console.log('coming back from sending email', data)
        
        rthis.setState({ 
          email_spinner: false,
          email_sent: true,
          value: rRichTextEditor.createEmptyValue(),
          group: "select",
          files: []
          // subject: "",
          // email_to_names: "",
          // to: "",
          // show_modal: false
        })
      }
    })
  }

  editorUnclick =() => {
    this.setState({ editorBorder: "" })
  }

  editorClick = () => {
    this.setState({ editorBorder: "borderOrange" })
  }

  userClicked = (selectedItem) => {
    var emails = "";
    if(selectedItem.email){
      this.state.to === ""? emails = selectedItem.email: emails = `${this.state.to},${selectedItem.email}`;
      console.log("EMAILS USER CLICK?", emails)
      this.setState({ to: emails})
    } else {
      alert("This user has no email")
    }
    
  }

  userClickedTeam = (selectedItem) => {
    var emails = ""
    this.setState({ toTeams: selectedItem}, ()=>{
      var team_emails = this.getEmails('team')
      this.state.to === "" ? emails = team_emails[0] : team_emails[0] ? emails = `${this.state.to},${team_emails[0]}`: emails = `${this.state.to}`
      this.setState({ to: emails})
    })
  }

  addSearchField(data, type) {
    console.log("TYPE ADD", type)
    if(type === 'user'){
      var search_map = {}
      data.forEach(user => {
        if(search_map.hasOwnProperty(user._id)){
          search_map[user._id] = search_map[user._id] + ` ${user.first_name} ${user.last_name} ${user.email}`
        } else if(search_map.hasOwnProperty(user.parent_id)){
          search_map[user.parent_id] = search_map[user.parent_id] + ` ${user.first_name} ${user.last_name} ${user.email}`
        } else {
          if(user._id){
            search_map[user._id] = `${user.first_name} ${user.last_name} ${user.email}`
          } else if (user.parent_id){
            search_map[user.id] = `${user.first_name} ${user.last_name} ${user.email}`
          }
        }
      })
      var temp_array = data.slice()
      temp_array.forEach((elem, index) => {
        var searchField = "";
        this.state.labelFields.forEach((objectPath) => {

          var field = deepValue(elem, objectPath.name);
          if (field) {
            searchField = searchField + " " + field;
          }
        })
       if(search_map[elem._id]){
         elem.searchField = search_map[elem._id]
       } else if (elem.parent_id && search_map[elem.parent_id]){
         elem.searchField = elem.searchField + " " + search_map[elem.parent_id]
       }
       elem.searchField = elem.searchField + " " + searchField;
      })
    } else {
      temp_array = data.slice()
  
      temp_array.forEach((elem, index) => {
        var searchField = "";
      if(type === 'teams') {
        this.state.labelFieldsTeam.forEach((objectPath) => {
          if(type === 'programs'){console.log("object TEM", objectPath)}
          var field = deepValue(elem, objectPath.name);
          if(type === 'programs'){console.log("Deepvalue TEM", field)}
          if (field) {
            searchField = searchField + " " + field;
          }
        })
      }
      if(type === 'programs'){
        this.state.labelFieldsPrograms.forEach((objectPath) => {
          if(type === 'programs'){
            //console.log("object", objectPath)
          }
          var field = deepValue(elem, objectPath.name, type);
          if(type === 'programs'){
            // console.log("Deepvalue", field)
          }
          if (field) {
            searchField = searchField + " " + field;
          }
        })
      }
        data[index].searchField = searchField;
      })
    }
    return temp_array;
  }

  filterList = (event) => {
      this.setState({selectedUsers: this.filter(this.state.all_users)});
  }

  filterListTeams = (event) => {
      this.setState({selectedTeams: this.filter(this.state.all_teams)});
  }

  filterListPrograms = (event) => {
    this.setState({selectedPrograms: this.filter(this.state.email_groups)})
}

  filter(originalList) {
      return originalList.filter((item) => {
    
          var searchWords = document.getElementById("search").value.toLowerCase().split(",");
          return searchWords.every((currentValue) => {
              return item.searchField.toLowerCase().search(currentValue.toLowerCase()) !== -1;
          });
      });
  }

  clickMarketingEmail = () => {
    var checked = this.state.marketingEmail;
    this.setState({marketingEmail: !checked });
  }

  getAjaxErrorMessage = (err, fallbackMessage) => {
    if (!err) {
      return fallbackMessage
    }

    const responseText = err.responseText || (err.responseJSON ? JSON.stringify(err.responseJSON) : '')
    if (responseText) {
      try {
        const parsed = JSON.parse(responseText)
        if (parsed && parsed.message) {
          return parsed.message
        }
      } catch (parseErr) {
        // Fall through to the raw response text.
      }
      return responseText
    }

    if (err.statusText) {
      return `${fallbackMessage}: ${err.statusText}`
    }

    return fallbackMessage
  }

  resolveAccessAndContext = async () => {
    if (!this.state.token) {
      window.alert("Please log in again before opening notifications.")
      window.location.href = document.location.origin + "/login"
      return false
    }

    try {
      const response = await $.ajax({
        headers: {
          "token": this.state.token,
        },
        method: "GET",
        dataType: "json",
        url: this.state.portal_endpoint,
      })

      const portalData = response && response.message ? response.message : response
      const currentUserType = portalData && portalData.type ? portalData.type : ''
      const organizations = portalData && Array.isArray(portalData.organizations) ? portalData.organizations : []

      if (currentUserType !== 'admin' && currentUserType !== 'manager') {
        window.alert("Notifications are available to admin accounts only.")
        return false
      }

      let organizationId = this.state.organization_id
      if (!organizationId && organizations.length > 0) {
        organizationId = currentUserType === 'admin' && portalData.current_user && Array.isArray(portalData.current_user.organization_ids) && portalData.current_user.organization_ids.length > 0
          ? portalData.current_user.organization_ids[0]
          : organizations[0]._id
      }

      if (!organizationId) {
        window.alert("Please select an organization before opening notifications.")
        return false
      }

      this.setState({ organization_id: organizationId })
      localStorage.setItem("organization_id", organizationId)
      localStorage.setItem("jwt", this.state.token)
      return true
    } catch (err) {
      window.alert("Could not verify your session. Please log in again.")
      return false
    }
  }

  loadNotificationData = async () => {
    var rthis = this
    const token = this.state.token || localStorage.getItem('jwt') || getParams().jwt || ''
    const organizationId = this.state.organization_id || localStorage.getItem("organization_id") || getParams().organization_id || ''
    if (!token) {
      window.alert("Please log in again before opening notifications.")
      return
    }
    if (!organizationId) {
      window.alert("Please select an organization before opening notifications.")
      return
    }
    if (token !== this.state.token || organizationId !== this.state.organization_id) {
      this.setState({ token, organization_id: organizationId })
    }
    this.setState({ spinner: true })
    await $.ajax({
        headers: {
            "token": token,
            "organization_id": organizationId,
            "function": "get_all_organization_emails"
        },
      method: "GET",
      contentType: 'application/json',
      url: this.state.get_all_emails_endpoint,
      success: function (data) {
        if (!data.errorMessage) {
          rthis.handleUserInitialFetch(data.message)
           //rthis.setState({ 
            // all_users: data.message, 
            // selectedUsers: rthis.addSearchField(data.message)})
        }
      },
      error: function (err){
        alert(rthis.getAjaxErrorMessage(err, 'Not authorized'))
      }
    })

    $.ajax({
        headers: {
            "token": token,
            "organization_id": organizationId,
            "function": "get_all_organization_emails"
        },
        method: "GET",
        dataType: "json",
        url: this.state.get_all_emails_endpoint,
    }).then(data => this.setState({all_emails: data.message}));

    await $.ajax({
        headers: {
          "token": token,
          "organization_id": organizationId
        },
        method: "GET",
        dataType: "json",
        url: this.state.get_groups_endpoint,
    }).then(data => this.setState({
      email_groups: data.message,
      selectedPrograms: this.addSearchField(data.message, "programs")
    }));

    $.ajax({
        headers: {
            "token": token,
            "organization_id": organizationId,
            "function": "get_all_teams"
        },
        method: "GET",
        dataType: "json",
        url: this.state.get_all_emails_endpoint
    }).then(data => this.setState({
                    all_teams: data.message,
                    selectedTeams: rthis.addSearchField(data.message, 'teams')
                  }, () => rthis.emailOneTeam()))
    if(getParams().program_id) {
      $("#group_selection").val("program");
    }

    if (this.state.broadcasts && this.state.selectedPrograms.length > 0) {
      var selectedProgram = this.state.selectedPrograms.find(program => {return program._id === this.state.program})
      console.log("what is selected program?", selectedProgram)
      var emailBody = 'Upcoming virtual training sessions:<br/>'
      selectedProgram.VTsessions.forEach(session => {
        let coach = this.state.all_users.find(user => user._id === session.coach)
        emailBody +=`<br/>${moment(session.date).format('MMMM-D YYYY')} ${session.start_time} - ${session.name} (${coach.first_name} ${coach.last_name}) - <a href="${session.link}" style="text-decoration: underline">Link</a>`
      })
      emailBody += "<br/><br/>First time joining a Virtual Training Session powered by Hoopstir? Refer to the documentation before getting started <a href='https://docs.google.com/document/d/1LLkxqx3uNpZa1UPuR9zzQBBqo45fmg7G0pffkt4JO5A/edit#' style='text-decoration: underline'>here</a>"
      emailBody += '<br/><br/> Thank you'
      this.setState({
        selectedPrograms: [selectedProgram],
        subject: "Virtual training sessions",
        value: RichTextEditor.createValueFromString(emailBody, 'html')
        })
    }
  }

  componentDidMount = async () => {
    const isAuthorized = await this.resolveAccessAndContext()
    if (isAuthorized) {
      this.loadNotificationData()
    }
  }

  handleUserInitialFetch = (data) => {
    console.log("handleUserInitialFetch", data)
    var temp_data = data.slice('')
    data.forEach( user => {
      if(user.extras && user.extras.secondary_parent && validateEmail(user.extras.secondary_parent.email)){
        temp_data.push({
          "email": user.extras.secondary_parent.email, 
          "first_name": user.extras.secondary_parent.first_name, 
          "last_name": user.extras.secondary_parent.last_name, 
          "phone": user.extras.secondary_parent.phone, 
          "parent_id": user._id,
          "type": 'Secondary'
        })
      }
    })
    temp_data = this.addSearchField(temp_data, 'user')
    console.log("set all users", temp_data)
    this.setState({
      all_users: temp_data, 
      selectedUsers: temp_data
    })
  }

  emailOneTeam = () => {
    if(getParams().toTeams){
      this.state.all_teams.forEach(team => {
        if(team.program_id === getParams().program_id && parseInt(getParams().toTeams) === parseInt(team.team_id)){
          var team_emails = this.getEmails('team', team)
          var emails = team_emails[0]
          this.setState({ to: emails, group: 'team', spinner: false})
        }
      })
    } else {
      this.setState({ spinner: false})
    }
  }

  getDivision(program){
    if(program){
      var division = program.charAt(0).toUpperCase() + program.slice(1);
      if(program.division === "co-ed"){
        division = "Co-Ed";
      }
    } else {
      var division = 'Undefined'
    }
    return division
  }

  getSeasons(){
    const historicalSeasons = getSeasons(true).slice(1).reverse()
    const upcomingSeasons = getSeasons(false).slice(0, 3)
    return [...historicalSeasons, ...upcomingSeasons]
  }

  uploadAttachment = () => {
    var fileToAdd = document.getElementById("file").files[0]
    var attachmentSizes = 0
    this.state.files.forEach(file => {
      attachmentSizes += file.size 
    })
    attachmentSizes +=  fileToAdd ? fileToAdd.size : 0
    if(fileToAdd && fileToAdd.size > 5242880){ 
      // 5MB - AWS SES mail size limit is 10MB but lambda payload is 6MB
      alert("The image size should be smaller than 5MB!");
      document.getElementById("file").value = "";
    } else if (attachmentSizes > 5242880){
      alert("You have exceeded the limit for all attachments");
      document.getElementById("file").value = "";
    } else {
      var attachments = this.state.files.slice()
      console.log("this.uploadInput.files[0]", this.uploadInput.files[0])
      console.log("fileToAdd", fileToAdd)
      attachments.push(this.uploadInput.files[0])
      this.setState({ files: attachments })
    }
  }

  deleteAttachment = (index) => {
    var attachments = this.state.files.slice()
    attachments.splice(index, 1)
    this.setState({ files: attachments })
  }

  render () {
    const { email_sent, spinner, group, files } = this.state
    return (
      <div className="full-page">

        <HamburgerNavbar />

        <div className="body-wrapper">
        <div className="margin-profile notifications-page">
                <div className="notifications-page-header">
                  <div className="programs-page-kicker">Admin Console</div>
                  <h2>Notifications</h2>
                </div>
             <div className="notifications-box">
                 <Form className="notifications-form">
                  <Row className="notifications-audience-row">
                    <Col sm={3}>
                      {
                                spinner ? <div className="enrolment-loader"></div>:
                                  <FormGroup id="emailForm">
                                  <ControlLabel>Select a group</ControlLabel>
                                  <FormControl className="opaque-grey" componentClass="select" id="group_selection" placeholder="select group" value={this.state.group} onChange={this.handleGroup}>
                                    <option value="select">...</option>
                                    <option value="organization">Entire Organization</option>
                                    <option value="parent">Just Parents</option>
                                    <option value="coach">Just Coaches</option>
                                    <option value="season">Entire Season</option>
                                    <option value="program">Select Programs</option>
                                    <option value="team">Select Teams</option>
                                    <option value="individual">Select Users</option>
                                  </FormControl>
                                </FormGroup>
                        }  
                        </Col> 
                        <Col sm={6}>
                        { group === "season" ?

                          <FormGroup>
                              <ControlLabel>Select Season</ControlLabel>
                              <FormControl className="opaque-grey"
                                componentClass="select"
                                id="season_selection"
                                placeholder="select season"
                                value={this.state.season}
                                onChange={this.handleSeason}>
                                  <option key="all" value="select">...</option>
                                {
                                  this.getSeasons().map((item, key) =>
                                  <option key={key} value={item}>{item.slice(0,1).toUpperCase() + item.slice(1)}</option>)
                                }
                              </FormControl>
                          </FormGroup>

                          //ADD TO: HERE
                          : null 

                      }
                        </Col>

                  </Row>

                  <Row className="notifications-recipient-row">
                    <Col sm={6}>
                    { group === "program" ?
                                  <div>
                                  <Row>
                                    <Col lg={12} sm={8}>
                                    <FormGroup>
                                    {/* <ControlLabel>Search for Program</ControlLabel> */}
                                    <FormControl placeholder="Programs Search" className="opaque-grey" name="search" type="text" id="search" onChange={this.filterListPrograms}/>
                                  </FormGroup>                                    
                                      <div className="notifications-data">
                                        <List2 data={this.state.selectedPrograms} labelFields={this.state.labelFieldsPrograms} action={this.handleProgramChange} />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>                    

                                : <div className='placeholder'></div>
                          }    

                          { group === "team" ?
                              <div>
                                    <Row>
                                      <Col  lg={12} sm={8}>
                                      <FormGroup>
                                      <FormControl placeholder="Teams Search" className="opaque-grey" name="search" type="text" id="search" onChange={this.filterListTeams}/>
                                    </FormGroup>                                      
                                      <div className="notifications-data">
                                        <List2 data={this.state.selectedTeams} labelFields={this.state.labelFieldsTeam} action={this.userClickedTeam} />
                                      </div>
                                      </Col>
                                      </Row>
                                            </div>
                                            : null
                                
                          }     

                          { group === "individual" ?
                              <div>
                            <Row>
                           <Col  lg={12} sm={8}>
                           <FormGroup>
                                      <FormControl placeholder="Users Search" className="opaque-grey" name="search" type="text" id="search" onChange={this.filterList}/>
                                   </FormGroup>                            
                           <div className="notifications-data">
                             <List2 data={this.state.selectedUsers} labelFields={this.state.labelFields} action={this.userClicked} />
                           </div>
                          </Col>
                         </Row>                            
                                </div>
                                : null
                          }                                                                

                    </Col>
                    <Col sm={6}>
                    { group === "program" ?
                                  <div>
                                  <FormGroup>
                                    <ControlLabel>Recipients</ControlLabel>
                                    <FormControl className="opaque-grey recipients recipients-program" componentClass="textarea" name="to" id="to" value={this.formatRecipientsForDisplay(this.state.to)} onChange={this.changeToEmail}/>
                                  </FormGroup>
                                </div>                    
                                : null
                          }     

                          { group === "team" ?
                              <div>
                                    <FormGroup>
                                      <ControlLabel>Recipients</ControlLabel>
                                      <FormControl className="opaque-grey recipients" name="to" type="text" id="to" value={`${this.state.to}`} onChange={this.changeToEmail}/>
                                    </FormGroup>
                                            </div>
                                            : null
                                
                          }       

                          { group === "individual" ?
                              <div>
                                    <FormGroup>
                                      <ControlLabel>Recipients</ControlLabel>
                                      <FormControl className="opaque-grey recipients" name="to" type="text" id="to" value={`${this.state.to}`} onChange={this.changeToEmail}/>
                                    </FormGroup>                         
                                </div>
                                : null
                          }                                                                

                    </Col>

                  </Row>

                  <Row className="notifications-message-row">
                  <Col sm={10} className='is-centered notifications-message-column'>
                  <Row className="notifications-subject-row">
                        <Col lg={12} sm={6}>
                          <FormGroup>
                            <ControlLabel>Subject</ControlLabel>
                            <FormControl className="opaque-grey" name="subject" type="text" id="subject" value={this.state.subject} onChange={this.handleSubjectChange} />
                          </FormGroup>
                        </Col>
                     </Row>
                     <Row className="notifications-editor-row">
                       <Col lg={12} sm={12}>
                          <FormGroup>
                            <RichTextEditor
                              value={this.state.value}
                              onChange={(value) =>  this.setState({ value })}
                              onFocus={this.editorClick}
                              onBlur={this.editorUnclick}
                              placeholder="start your email"
                              id="textEditor"
                              className={this.state.editorBorder}
                              toolbarConfig={toolbarConfig}
                            />
                          </FormGroup>
                       </Col>
                     </Row>
                     <Row className="notifications-actions-row">
                       <Col lg={6} sm={12}>
                        {/* <ControlLabel>Attachments (max size: 5MB)</ControlLabel> */}
                          <label htmlFor="file" className="upload-icon">
                            <FontAwesomeIcon icon={faPaperclip} color='#5563b8' size="2x" style={{padding: '3px'}}/>
                            <span className="upload-lbl">Add attachment (max size: 5MB)</span>
                          </label>
                          <input onChange={this.uploadAttachment} name="file" id="file" ref={(ref) => { this.uploadInput = ref}} type="file" className="hidden"/>
                          <br/>
                          <br/>

                        {
                          files.length > 0 ? 
                          files.map((file, index) => {
                            return <div className="file-attached" key={index}>
                              <p>File Attached: {file.name}
                              <FontAwesomeIcon icon={faTimes} className="file-attachment" style={{marginLeft: '1em', cursor: 'pointer'}} color='#5563b8' size="1x" onClick={() => this.deleteAttachment(index)}/>
                              </p>
                            </div>
                          })
                          :
                          ""
                        }
                       </Col>
                      <Col lg={6} sm={3}>
                        <Checkbox inline name="marketimargin-2ng" id="marketing" onChange={this.clickMarketingEmail}>
                          This is a marketing email. Do not send to families that have opted out.
                          
                        </Checkbox><br/><br/>
                        <Button className="button2" onClick={this.handleModalShow}>
                          Preview
                        </Button>
                        <br/><br/><br/>
                        <Modal
                          show={this.state.show_modal}
                          onHide={this.handleModalClose}
                          dialogClassName={`notifications-modal ${email_sent ? 'notifications-modal-success' : 'notifications-modal-preview'}`}
                        >
                          {
                            email_sent ?
                              <Fragment>
                                <Modal.Body className="notifications-modal-body notifications-success-body">
                                  <div className="notifications-success-card">
                                    <div className="notifications-success-icon-wrap">
                                      <FontAwesomeIcon icon={faCheck} color="#16a34a" size="4x" className="notifications-success-icon"/>
                                    </div>
                                    <div className="notifications-success-copy">
                                      <div className="notifications-success-kicker">Sent</div>
                                      <h3 className="notifications-success-title">Email delivered</h3>
                                      <p className="notifications-success-text">
                                        Your notification has been sent successfully.
                                      </p>
                                      <div className="notifications-success-meta">
                                        <span><strong>Subject:</strong> {this.state.subject || 'Untitled message'}</span>
                                        <span><strong>Audience:</strong> {this.state.group === 'select' ? 'Selected recipients' : this.state.group}</span>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Body>
                              </Fragment>
                              :
                              <Fragment>
                                <Modal.Header className="notifications-modal-header">
                                  <div className="notifications-modal-heading-group">
                                    <div className="notifications-modal-kicker">Preview</div>
                                    <Modal.Title className="notifications-modal-title">Subject: {this.state.subject}</Modal.Title>
                                  </div>
                                  {this.state.marketingEmail? <span className="notifications-marketing-badge">Marketing Email</span>: ""}
                                </Modal.Header>
	                                <Modal.Body className="notifications-modal-body">
	                                  <div className="notifications-recipient-panel">
                                      <div className="notifications-label">To</div>
	                                    <ul className="notifications-recipient-list">
	                                      {(group === "individual" || group === "team"|| group === "program")?
	                                        (
	                                          this.state.to.split(",").map((email, index)=>
	                                            <li key={`recipient-email-${index}-${email}`}>{email}</li>)
	                                        ):
	                                        (
	                                          this.state.email_to_names.split(",").map((email, index)=>
	                                            <li key={`recipient-name-${index}-${email}`}>{email}</li>
	                                          )
	                                        )
	                                      }
	                                    </ul>
	                                  </div>
                                  <div className="notifications-message-panel" dangerouslySetInnerHTML={{__html: this.state.value.toString("html")}} />
                                  {
                                    files.length > 0 &&
	                                    <div className="notifications-attachments-panel">
	                                      <div className="notifications-label">Attached</div>
	                                      <div className="notifications-attachments-list">
	                                        {
	                                          files.map((file, index) => {
	                                           return <p key={`attachment-${index}-${file.name}`}>{file.name}</p>
	                                          })
	                                        }
	                                      </div>
	                                    </div>
	                                  } 
                                </Modal.Body>
                              </Fragment>
                            }
                             <Modal.Footer className="notifications-modal-footer">
                               <Row className="notifications-modal-actions">
                                 {
                                    email_sent ?
                                    ""
                                    :
                                    <Col sm={4} className="pull-right notifications-modal-primary">
                                    {
                                      this.state.email_spinner ? 
                                      <div className="enrolment-loader"></div> :
                                      <Button className="button2 modalbtn notifications-modal-send" onClick={this.handleSubmit}>
                                        SEND
                                      </Button>
                                    }
                                    </Col>
                                 }
                                 <Col sm={3} className="pull-right notifications-modal-secondary">
                                  <Button className="button2 modalcancel notifications-modal-close" onClick={this.handleModalClose}>
                                    {email_sent ? "Close": "Cancel"}
                                  </Button>
                                 </Col>
                                </Row>
                             </Modal.Footer>
                           </Modal>
                         </Col>
                     </Row>                  

                  </Col>                    
                  </Row>

                </Form>
              </div>
           </div>
        </div>
      </div>
    );
  }
}

export default notifications;


const toolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
    {label: 'Italic', style: 'ITALIC'},
    {label: 'Underline', style: 'UNDERLINE'}
  ],
  BLOCK_TYPE_DROPDOWN: [
    {label: 'Normal', style: 'unstyled'},
    {label: 'Heading Small', style: 'header-three'},
    {label: 'Heading Medium', style: 'header-two'},
    {label: 'Heading Large', style: 'header-one'}
  ],
  BLOCK_TYPE_BUTTONS: [
    {label: 'UL', style: 'unordered-list-item'},
    {label: 'OL', style: 'ordered-list-item'}
  ]
};
